import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/listing-item-01.jpg'


const _hoisted_1 = { class: "listing-item" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "listing-badge now-open" }, "Now Open", -1)
const _hoisted_4 = { class: "listing-item-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "tag" }, "Eat & Drink", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "like-icon" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "star-rating",
  "data-rating": "3.5"
}, [
  /*#__PURE__*/_createVNode("div", { class: "rating-counter" }, "(12 reviews)")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_router_link, {
      to: { path: '/places/' + _ctx.place.slug },
      class: "listing-item-container"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("h3", null, _toDisplayString(_ctx.place.name), 1),
            _createVNode("span", null, _toDisplayString(_ctx.place.address.addressLine1) + ", " + _toDisplayString(_ctx.place.address.city), 1)
          ]),
          _hoisted_6
        ]),
        _hoisted_7
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}